<template>
  <FormOverlay
    id="fragments"
    :title="$t('fragmentsPlaceDialogTitle', 'Add fragment block')"
    icon="reusable"
    @close="onClose"
  >
    <div class="bk-library-dialog">
      <p class="bk-lead">
        {{
          $t(
  "fragmentsPlaceDialogLead",
  "Select a block fragment to add to the page."
)
        }}
      </p>
      <div class="bk">
        <div class="bk-form-group">
          <div>
            <label class="bk-form-label" for="library_search">
              {{ $t("fragmentsPlaceDialogSearchLabel", "Filter fragments") }}
            </label>
            <input
              id="fragments_search"
              v-model="searchText"
              type="text"
              class="bk-form-input"
              :placeholder="
  $t('fragmentsPlaceDialogSearchPlaceholder', 'Search fragments')
"
              required
            />
          </div>
        </div>
      </div>
      <div class="bk-library-dialog-content">
        <ul class="bk-library-dialog-list">
          <li
            v-for="(item, index) in fragments"
            :key="item.name"
            :class="{
  'bk-is-selected': selectedItem === item.name
}"
            @click="selectedItem = item.name"
          >
            <FragmentItem
              v-show="visible === null || visible.includes(item.name)"
              :name="item.name"
              :label="item.label"
              :description="item.description"
              :index="index"
            />
          </li>
        </ul>
      </div>
    </div>
    <template #footer>
      <button class="bk-button bk-is-primary" @click="onSubmit">
        {{ $t("fragmentsPlaceDialogSubmitButton", "Add selected fragment") }}
      </button>
    </template>
  </FormOverlay>
</template>

<script setup>
import { FormOverlay } from "#blokkli/components";
import { falsy } from "#blokkli/helpers";
import { ref, useBlokkli, computed, watch } from "#imports";
import FragmentItem from "./Item/index.vue";
const props = defineProps({
  field: { type: Object, required: true }
});
const { $t, definitions } = useBlokkli();
const emit = defineEmits(["close", "submit"]);
const searchText = ref("");
const listEl = ref(null);
const selectedItem = ref("");
const allowedInField = computed(() => props.field.allowedFragments || []);
const fragments = computed(
  () => definitions.fragmentDefinitions.value.filter(
    (v) => allowedInField.value.includes(v.name)
  )
);
const onSubmit = () => {
  if (selectedItem.value) {
    emit("submit", selectedItem.value);
  }
};
const onClose = () => {
  emit("close");
};
const elements = ref([]);
const buildElements = () => {
  if (!listEl.value) {
    return;
  }
  elements.value = [...listEl.value.querySelectorAll(".bk-library-list-item")].map((el) => {
    if (el instanceof HTMLElement) {
      const uuid = el.dataset.libraryItemUuid;
      if (uuid) {
        return {
          uuid,
          text: el.textContent?.toLowerCase() || ""
        };
      }
    }
  }).filter(falsy);
};
watch(searchText, () => {
  if (!elements.value.length) {
    buildElements();
  }
});
const visible = computed(() => {
  if (!searchText.value || !elements.value.length) {
    return null;
  }
  return elements.value.filter((v) => v.text.includes(searchText.value.toLowerCase())).map((v) => v.uuid);
});
</script>
